var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleLounge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -2112.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Lounge",
    transform: "translate(2352.000000, 2112.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1,8.3 C4,8.3 4.8,8.8 5.1,9.7 L5.1,9.7 L7,18.7 L8.2,18.6 L13.1,18.1 L13.1,18.1 L13.6,18.1 C14.7,18.1 15.7,18.5 16.5,19.1 L16.5,19.1 L16.599537,19.199537 L16.599537,19.199537 C16.8,19.3 17,19.4 17.1,19.6 C17.1,19.7 17.2,19.7 17.2,19.8 C17.3,19.9 17.4,20.1 17.5,20.2 C17.6,20.3 17.6,20.5 17.7,20.6 C17.7,20.7 17.8,20.8 17.8,20.9 C17.9,21.1 18,21.3 18,21.6 C18.1,22 18,24 18,24 L18,24 L16.1,24 L17.3,32 L16.2,32 L13.9,25.5 L8.4,25.5 L6.1,32 L5,32 L6.1,24 C4.9,23.7 3.9,22.7 3.7,21.4 L3.7,21.4 L2,8.7 L2.14980469,8.59667969 C2.4984375,8.3765625 2.8375,8.3 3.1,8.3 Z M21.7,17.2 L24.3,32 L23.5,32 C22.5,32 21.7,31.4 21.4,30.4 L21.4,30.4 L19,21.7 L19,21.5 C18.8,19.9 17.9,18.6 16.5,17.8 L16.5,17.8 L21.7,17.2 Z M7.3,6.7 C8.9,6.5 10.5,7.5 11.1,9.1 L11.1,9.1 L13.5,17.1 L13.5,17.1 L13.2,17.1 L8.2,17.6 L6,6.9 Z M24.5,0 C27.5,0 30,2.5 30,5.5 C30,8.5 27.5,11 24.5,11 C21.5,11 19,8.5 19,5.5 C19,2.5 21.5,0 24.5,0 Z M25.1,1.7 C24.4,1.7 24.1,2.2 24.1,2.7 L24.1,2.7 L24.1,4.8 L22,4.8 C22,5.5 22.5,5.8 23,5.8 L23,5.8 L25.1,5.8 Z M8,0 C9.38071187,0 10.5,1.11928813 10.5,2.5 C10.5,3.88071187 9.38071187,5 8,5 C6.61928813,5 5.5,3.88071187 5.5,2.5 C5.5,1.11928813 6.61928813,0 8,0 Z",
    id: 297
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleLounge);
export default __webpack_public_path__ + "static/media/life-and-people-lounge.6d49ca77.svg";
export { ForwardRef as ReactComponent };